import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { useTranslation } from '../hooks/useTranslation';
import './ProductCard.css';

const ProductCard = ({ prodotto }) => {
  const navigate = useNavigate();
  const { addToCart } = useCart();
  const { t } = useTranslation();
  const stock = typeof prodotto.quantita === 'number' ? prodotto.quantita : (prodotto.stock ?? 0);
  const isOutOfStock = stock <= 0;

  const handleAddToCart = (e) => {
    e.preventDefault();
    if (isOutOfStock) {
      return;
    }
    addToCart(prodotto, 1);
  };

  const handleCardClick = () => {
    navigate(`/prodotto/${prodotto.id}`);
  };

  return (
    <div className={`product-card ${isOutOfStock ? 'sold-out' : ''}`}>
      {/* Immagine cliccabile */}
      <div className="product-image" onClick={handleCardClick}>
        <img 
          src={prodotto.foto || 'https://via.placeholder.com/400x400/2C5F2D/FFFFFF?text=Prodotto'} 
          alt={prodotto.nome} 
        />
        {isOutOfStock && (
          <span className="stock-badge">
            {t('product.out_of_stock')}
          </span>
        )}
      </div>
      
      {/* Nome e prezzo */}
      <div className="product-info">
        <h3 className="product-name" onClick={handleCardClick}>{prodotto.nome}</h3>
        <p className="product-price">€ {parseFloat(prodotto.prezzo).toFixed(2)}</p>
      </div>
      <div className="product-stock-info">
        {isOutOfStock
          ? <span className="stock-message out">{t('product.out_of_stock')}</span>
          : <span className="stock-message in">{t('product.stock_available', { values: { quantity: stock } })}</span>}
      </div>
      
      {/* Bottone aggiungi al carrello */}
      <div className="product-controls">
        <button 
          className="btn-add-cart" 
          onClick={handleAddToCart}
          disabled={isOutOfStock}
        >
          {isOutOfStock ? t('product.out_of_stock_short') : t('product.add_to_cart')}
        </button>
      </div>
    </div>
  );
};

export default ProductCard;